import React from 'react';
import { Route, RouteComponentProps, useHistory } from 'react-router-dom';

export default function PublicRoute({ component, route, ...rest }: { component: React.ComponentType<RouteComponentProps<any>>; route?: any }) {
  const Component = component;
  const history = useHistory();
  history.listen((location: any) => {
    // console.log('location', location);
    // console.log(route);
  });
  return <Route {...rest} render={(props) => <Component {...props} />} />;
}
